import { render, staticRenderFns } from "./topicos.vue?vue&type=template&id=1684d20b&"
import script from "./topicos.vue?vue&type=script&lang=js&"
export * from "./topicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports